const GET_DEFAULT_CONTAINER_PROPS = () => ({
  redirects: {
    link: {
      to: "/"
    }
  }
});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
